import type { GuardWebAccountGate } from "./account-gate.ts";

export function WorkspaceGateScreen({
  gate,
  isRefreshing,
  onRetry,
  onSelectAccount,
  onSignOut,
  selectingAccountId,
}: {
  readonly gate: GuardWebAccountGate;
  readonly isRefreshing: boolean;
  readonly onRetry: () => void;
  readonly onSelectAccount: (accountId: string) => void;
  readonly onSignOut: () => void;
  readonly selectingAccountId: string | null;
}) {
  if (gate.status === "loading") {
    return (
      <section className="workspace-gate" aria-busy="true">
        <h2 className="workspace-gate__title">Workspace</h2>
        <p className="workspace-gate__detail">{gate.message}</p>
      </section>
    );
  }

  if (gate.status === "blocked" || gate.status === "error") {
    return (
      <section className="workspace-gate workspace-gate--blocked" role="alert">
        <h2 className="workspace-gate__title">No workspace access</h2>
        <p className="workspace-gate__detail">{gate.message}</p>
        <div className="workspace-gate__actions">
          <button className="workspace-gate__btn" type="button" onClick={onRetry} disabled={isRefreshing}>
            {isRefreshing ? "Checking…" : "Try again"}
          </button>
          <button className="workspace-gate__btn workspace-gate__btn--ghost" type="button" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </section>
    );
  }

  if (gate.status === "picker") {
    return (
      <section className="workspace-gate">
        <h2 className="workspace-gate__title">Choose workspace</h2>
        <p className="workspace-gate__detail">{gate.message}</p>
        <ul className="workspace-gate__list">
          {gate.accounts.map((account) => (
            <li key={account.accountId}>
              <button
                className="workspace-gate__pick"
                type="button"
                disabled={selectingAccountId === account.accountId}
                onClick={() => onSelectAccount(account.accountId)}
              >
                <span className="workspace-gate__pick-name">{account.accountName}</span>
                <span className="workspace-gate__pick-role">{account.role}</span>
              </button>
            </li>
          ))}
        </ul>
      </section>
    );
  }

  return null;
}
